export type ToolEvent = 'file_open' | 'export_started' | 'export_success' | 'download_started' | 'processing_error';
export type ToolCategory = 'video' | 'audio' | 'images' | 'pdf' | 'vector' | 'library' | 'project' | 'animation' | 'layout' | 'photos';
export interface ToolEventDetails {
  category: ToolCategory;
  stage?: 'open' | 'export' | 'download' | 'storage';
  format?: string;
}

// Deliberately accepts no filenames, file IDs, error text or document contents.
// The counter listener applies its own allowlist before sending anything.
export function trackToolEvent(name: ToolEvent, details: ToolEventDetails): void {
  if (typeof window === 'undefined') return;
  try {
    const detail = {
      name, category: details.category, stage: details.stage, format: details.format,
    };
    if (window.parent !== window) window.parent.postMessage({ channel: 'editall:tool-event', ...detail }, window.location.origin);
    else window.dispatchEvent(new CustomEvent('editall:tool-event', { detail }));
  } catch { /* Analytics must never interrupt editing or a download. */ }
}
